_BannerFlowApp.directive("tree", function (RecursionHelper) {
    return {
        restrict: "E",
        scope: { node: "=", selectFunc: "=selectFunc", isFirst: "=isFirst", parentMode: "=parentMode" },
        // tooltip="{{ getTooltip(node) }}" tooltip-placement="left"
        template:
            '<div ng-click="select(node)" ng-class="{ isParent : (node.Descendants.length > 1 ? true : false), first : isFirst, selected: node.selected }" class="feed-field-node depth{{ depth }}"><i class="fa fa-code"></i>&nbsp;&nbsp;<span class="field-title">{{ node.Name }}</span><span class="feed-element-count">{{ node.Count != 0 ? node.Count + " items" : "" }}</span><span class="feed-sample-data">{{ node.Data.join(", ") }}</span><div class="tree-dots"></div></div>' +
            '<ul class="feed-tree-list" ng-class="{ multiple : node.Descendants.length > 1 }">' +
            '<li ng-repeat="nodeChild in node.Descendants">' +
            '<tree node="nodeChild" select-func="selectFunc" parent-mode="parentMode"></tree>' +
            "</li>" +
            "</ul>",
        compile: function (element) {
            return RecursionHelper.compile(
                element,
                function ($scope, iElement, iAttrs, controller, transcludeFn) {
                    $scope.depth++;
                    $scope.select = function (node) {
                        if ($scope.parentMode === 1) {
                            if (node.Descendants.length > 1) {
                                $scope.selectFunc(node);
                            }
                        } else {
                            if (node.Descendants.length > 1) {
                                $scope.selectFunc(node.Descendants);
                            } else {
                                $scope.selectFunc(node);
                            }
                        }
                    };
                    $scope.getTooltip = function (node) {
                        var arr = node.Path.split(".");
                        var str = "";

                        for (var i = 0; i < arr.length - 1; i++) {
                            str += arr[i] + " > ";
                        }

                        return str;
                    };
                }
            );
        },
        controller: function ($scope, $attrs) {}
    };
});
